import {NgModule} from "@angular/core";
import {BaseCrudPagesComponent} from "./base-crud-pages.component";
import {BaseDeletePagesComponent} from "./base-delete-pages.component";
import {BaseEditPagesComponent} from "./base-edit-pages.component";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {InlineSVGModule} from "ng-inline-svg";
import {HttpClientModule} from "@angular/common/http";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {BaseCrudBpmnPagesComponent} from "./base-crud-bpmn-pages.component";
import {BaseBpmnEditPagesComponent} from "./base-bpmn-edit-pages.component";
import {CommonSelect2Component} from "../shared/components/base-select-2/common-select2.component";
import {BaseSelect2Component} from "../shared/components/base-select-2/base-select2.component";
import {MatInputModule} from "@angular/material/input";
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatCardModule} from "@angular/material/card";
import {MatRadioModule} from "@angular/material/radio";
import {MatFormFieldModule} from "@angular/material/form-field";
import {DateSelectComponent} from "../shared/components/date/date-select.component";
import {BaseEditBpmnComponent} from "../shared/components/base-edit-bpmn/base-edit-bpmn.component";
import {BaseEditBpmnDecisionComponent} from "../shared/components/base-edit-bpmn-decision/base-edit-bpmn-decision.component";
import {DrawComponent} from "../shared/components/draw/draw.component";
import {SignaturePadModule} from "angular2-signaturepad";
import {SingleUploadFileComponent} from "../shared/components/single-upload-file/single-upload-file.component";
import {DiagramComponent} from "../shared/components/diagram/diagram.component";
import {DiagramTesComponent} from "../shared/components/diagram/diagram-tes.component";
import {TagFileComponent} from "../shared/components/tag/tag-file.component";
import {BaseCrudBpmnTodoPagesComponent} from "./base-crud-bpmn-todo-pages.component";
import {DiagramReqDocComponent} from "../shared/components/diagram/diagram-req-doc.component";
import {DateRangeSelectComponent} from "../shared/components/date-range/date-range-select.component";
import {DiagramDelegateAppComponent} from "../shared/components/diagram/diagram-delegate-app.component";

@NgModule({
  declarations: [
    BaseCrudPagesComponent,
    BaseDeletePagesComponent,
    BaseEditPagesComponent,
    DiagramComponent,
    BaseCrudBpmnPagesComponent,
    BaseBpmnEditPagesComponent,
    DiagramTesComponent,
    BaseSelect2Component,
    CommonSelect2Component,
    DateSelectComponent,
    BaseEditBpmnComponent,
    BaseEditBpmnDecisionComponent,
    DrawComponent,
    SingleUploadFileComponent,
    TagFileComponent,
    BaseCrudBpmnTodoPagesComponent,
    DiagramReqDocComponent,
    DateRangeSelectComponent,
    DiagramDelegateAppComponent
  ],
  imports: [
    ReactiveFormsModule,
    CommonModule,
    HttpClientModule,
    InlineSVGModule,
    NgbModule,
    FormsModule,
    MatInputModule,
    MatCheckboxModule,
    MatSelectModule,
    MatCardModule,
    MatRadioModule,
    MatFormFieldModule,
    NgxMatSelectSearchModule,
    SignaturePadModule,
  ],
  exports: [
    BaseCrudPagesComponent,
    BaseDeletePagesComponent,
    BaseEditPagesComponent,
    BaseCrudBpmnPagesComponent,
    BaseBpmnEditPagesComponent,
    BaseSelect2Component,
    CommonSelect2Component,
    DateSelectComponent,
    BaseEditBpmnComponent,
    BaseEditBpmnDecisionComponent,
    DrawComponent,
    SingleUploadFileComponent,
    DiagramComponent,
    DiagramTesComponent,
    TagFileComponent,
    BaseCrudBpmnTodoPagesComponent,
    DiagramReqDocComponent,
    DateRangeSelectComponent,
    DiagramDelegateAppComponent
  ]
})

export class CrudModule { }
